import { getFlutterFromDate } from "@services/timeHelpers";
import { Timestamp } from "firebase/firestore";
import { colors } from "sexy";
import {
  Broadcast,
  ContactInfos,
  EmailSent,
  EmailTemplate,
  PartnerInfos,
  Project,
  ProjectDocument,
  ProjectFolder,
  ProjectHistoryEvent,
  ProjectPhoto,
  ProjectTheme,
} from "types";
import { LibraryDocument } from "types/library_document";

export const sample_photos: ProjectPhoto[] = [
  {
    id: "photo1",
    file: {
      id: "file1",
      url: "https://cdn.prod.website-files.com/62d597b300f3e8bc76aff8db/64cd4fb43a1421b63acb582d_floorplan%20easy.png",
      name: "photo1.png",
      created_at: getFlutterFromDate(new Date("2021-07-10T10:00:00")),
      octets: 150000,
    },
  },
  {
    id: "photo2",
    file: {
      id: "file2",
      url: "https://cdn.cgdream.ai/_next/image?url=https%3A%2F%2Fapi.cgdream.ai%2Frails%2Factive_storage%2Fblobs%2Fredirect%2FeyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBCRWJNUWdFPSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ%3D%3D--d6b71d95510b8e2a8c0e3d630ad67c6d27496a51%2F56326c54-e6bb-43d6-816d-eeebb05e7a45_0.png&w=1080&q=95",
      name: "photo2.png",
      created_at: getFlutterFromDate(new Date("2021-07-11T10:00:00")),
      octets: 200000,
    },
    hidden: true,
  },
  {
    id: "photo3",
    file: {
      id: "file3",
      url: "https://deep-image.ai/blog/content/images/2023/11/3d2dc036-07a1-4e51-8e24-f901f06a0431.png",

      name: "photo3.png",
      created_at: getFlutterFromDate(new Date("2021-07-12T10:00:00")),
      octets: 250000,
    },
  },
];

export const options = [
  {
    value: "something",
    label: "Something",
  },
  {
    value: "another",
    label: "Another",
  },
  {
    value: "third",
    label: "Third",
  },
  {
    value: "fourth",
    label: "Fourth",
  },
  {
    value: "fifth",
    label: "Fifth",
  },
  {
    value: "sixth",
    label: "Sixth",
  },
  {
    value: "seventh",
    label: "Seventh",
  },
  {
    value: "eighth",
    label: "Eighth",
  },
  {
    value: "ninth",
    label: "Ninth is a bit longer because I want to test text wrapping",
  },
];

export const sample_documents: ProjectDocument[] = [
  {
    id: "doc1",
    name: "Contrat_de_travail.pdf",
    file: {
      id: "file_doc1",
      url: "https://example.com/documents/contrat_de_travail.pdf",
      name: "contrat_de_travail.pdf",
      created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
      octets: 50000,
    },
  },
  {
    id: "doc2",
    name: "Fiche_de_paie_Janvier_2024.pdf",
    file: {
      id: "file_doc2",
      url: "https://example.com/documents/fiche_de_paie_janvier_2024.pdf",
      name: "fiche_de_paie_janvier_2024.pdf",
      created_at: getFlutterFromDate(new Date("2024-06-05 15:30")),
      octets: 30000,
    },
  },
  {
    id: "doc3",
    name: "Plan_de_construction.pdf",
    file: {
      id: "file_doc3",
      url: "https://example.com/documents/plan_de_construction.pdf",
      name: "plan_de_construction.pdf",
      created_at: getFlutterFromDate(new Date("2024-06-10 09:15")),
      octets: 100000,
    },
  },
  {
    id: "doc4",
    name: "Devis_electricien.pdf",
    file: {
      id: "file_doc4",
      url: "https://example.com/documents/devis_electricien.pdf",
      name: "devis_electricien.pdf",
      created_at: getFlutterFromDate(new Date("2024-06-12 11:00")),
      octets: 40000,
    },
  },
  {
    id: "doc5",
    name: "Permis_de_construire.pdf",
    file: {
      id: "file_doc5",
      url: "https://example.com/documents/permis_de_construire.pdf",
      name: "permis_de_construire.pdf",
      created_at: getFlutterFromDate(new Date("2024-06-15 14:45")),
      octets: 60000,
    },
  },
  {
    id: "doc6",
    name: "Assurance_decennale.pdf",
    file: {
      id: "file_doc6",
      url: "https://example.com/documents/assurance_decennale.pdf",
      name: "assurance_decennale.pdf",
      created_at: getFlutterFromDate(new Date("2024-06-18 16:30")),
      octets: 45000,
    },
  },
];

export const sample_library_documents: LibraryDocument[] = [
  {
    id: "libdoc1",
    name: "Fournisseur d'eau communal.pdf",
    file: {
      id: "file_libdoc1",
      url: "https://example.com/library_documents/fournisseur_eau_communal.pdf",
      name: "fournisseur_eau_communal.pdf",
      created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
      octets: 50000,
    },
  },
  {
    id: "libdoc2",
    name: "Mode d'emploi pour l'obtention de l'électricité pour votre compteur de chantier électrique.pdf",
    file: {
      id: "file_libdoc2",
      url: "https://example.com/library_documents/mode_emploi_obtention_electricite_compteur_chantier.pdf",
      name: "mode_emploi_obtention_electricite_compteur_chantier.pdf",
      created_at: getFlutterFromDate(new Date("2024-06-05 15:30")),
      octets: 30000,
    },
  },
];

export const sample_repertorys = [
  "Contrat - Appels d'offres",
  "Plans - Permis de construire",
  "Devis",
  "Décennale - Assurance",
  "MAP",
  "Compte rendu - Photos chantier",
  "Plans d'exécution",
  "Dossier RH",
  "Dossier Financier",
  "Dossier Projets",
];

export const sample_folders: ProjectFolder[] = [
  {
    id: "folder1",
    name: "Dossier de construction",
    documents: [sample_documents[0], sample_documents[1]],
  },
  {
    id: "folder2",
    name: "Dossier de permis de construire",
    documents: [sample_documents[2], sample_documents[3]],
  },
  {
    id: "folder3",
    name: "Dossier de devis",
    documents: [sample_documents[4], sample_documents[5]],
    sub_folders: [
      {
        id: "subfolder1",
        name: "Devis électricien",
        documents: [sample_documents[3]],
      },
      {
        id: "subfolder2",
        name: "Devis maçon",
        documents: [],
      },
    ],
  },
  {
    id: "folder4",
    name: "Dossier de photos de chantier",
    documents: [sample_documents[0], sample_documents[2], sample_documents[4]],
  },
  {
    id: "folder5",
    name: "Dossier de plans d'exécution",
    documents: [],
  },
  {
    id: "folder6",
    name: "Dossier de compte rendu de réunion",
    documents: [],
  },
  {
    id: "folder7",
    name: "Dossier de suivi financier",
    documents: [sample_documents[1], sample_documents[3], sample_documents[5]],
  },
  {
    id: "folder8",
    name: "Dossier de ressources humaines",
    documents: [sample_documents[0], sample_documents[5]],
  },
];
export const themes: ProjectTheme[] = [
  {
    id: "theme1",
    label: "Administratif",
    steps: [
      {
        id: "step1",
        label: "Études",
        controlpoints: [
          {
            id: "cp1",
            label: "Étude géotechnique G2",
            state: "completed",
            hidden: true,
          },
          {
            id: "cp2",
            label: "Étude béton",
            state: "completed",
          },
          {
            id: "cp3",
            label: "Étude hydrogéologique pour assainissement",
            state: "not_applicable",
          },
          {
            id: "cp4",
            label: "Étude thermique",
            state: "completed",
          },
        ],
      },
    ],
  },
  {
    id: "theme2",
    label: "VT",
    steps: [
      {
        id: "step2",
        label: "Visite du terrain validée",
        controlpoints: [
          {
            id: "cp5",
            label: "Visite du terrain validée",
            state: "completed",
          },
        ],
      },
    ],
  },
  {
    id: "theme3",
    label: "Mise au point technique",
    steps: [
      {
        id: "step3",
        label: "Mise au point technique",
        controlpoints: [
          {
            id: "cp6",
            label: "Réunion technique (MAP)",
            state: "completed",
          },
        ],
      },
      {
        id: "step4",
        label: "Contrôle mise au point technique",
        controlpoints: [
          {
            id: "cp7",
            label: "Validation des plans d'exécution",
            state: "completed",
          },
          {
            id: "cp8",
            label: "Validation des plans de la cuisine",
            state: "completed",
          },
        ],
      },
    ],
  },
  {
    id: "theme4",
    label: "Avant travaux",
    steps: [
      {
        id: "step5",
        label: "Viabilisation",
        controlpoints: [
          {
            id: "cp9",
            label: "EDF",
            state: "completed",
          },
          {
            id: "cp10",
            label: "Télécom",
            state: "completed",
          },
          {
            id: "cp11",
            label: "Gaz",
            state: "not_applicable",
          },
          {
            id: "cp12",
            label: "Eau usée",
            state: "completed",
          },
          {
            id: "cp13",
            label: "Eau potable",
            state: "completed",
          },
          {
            id: "cp14",
            label: "Eaux pluviales",
            state: "completed",
          },
        ],
      },
      {
        id: "step6",
        label: "Mise en place du panneau de chantier",
        controlpoints: [
          {
            id: "cp15",
            label: "Mise en place du panneau de chantier",
            state: "completed",
          },
        ],
      },
      {
        id: "step7",
        label: "Avant travaux",
        controlpoints: [
          {
            id: "cp16",
            label: "Ouverture compteur d'eau",
            state: "completed",
            associated_email_template_id: "model5",
          },
          {
            id: "cp17",
            label: "Pose du compteur provisoire",
            state: "completed",
            associated_email_template_id: "model6",
          },
          {
            id: "cp18",
            label: "Rappel dépôt de la DROC",
            state: "completed",
            associated_email_template_id: "model7",
          },
        ],
      },
    ],
  },
  {
    id: "theme5",
    label: "Terrassement",
    steps: [
      {
        id: "step8",
        label: "Terrassement",
        controlpoints: [
          {
            id: "cp19",
            label: "RDV avec le client sur chantier - contrôle terrassement",
            state: "completed",
          },
          {
            id: "cp20",
            label: "Terrassement",
            state: "completed",
          },
          {
            id: "cp21",
            label: "Accès au chantier",
            state: "completed",
          },
          {
            id: "cp22",
            label: "Évacuation des terres",
            state: "completed",
          },
        ],
      },
    ],
  },
  {
    id: "theme6",
    label: "Gros œuvre",
    steps: [
      {
        id: "step9",
        label: "Fondations / Dallage",
        controlpoints: [
          {
            id: "cp23",
            label: "Programmation intervention du plombier",
            state: "completed",
          },
          {
            id: "cp24",
            label: "Fonds de fouille",
            state: "completed",
          },
          {
            id: "cp25",
            label: "Coulage des fondations",
            state: "completed",
          },
          {
            id: "cp26",
            label: "Validation de l'implantation des rupteurs thermiques",
            state: "completed",
          },
          {
            id: "cp27",
            label: "Limite de propriété correcte",
            state: "completed",
          },
          {
            id: "cp28",
            label: "Présence et contrôle des attentes pour poteaux",
            state: "missed",
          },
          {
            id: "cp29",
            label: "Contrôle réseaux sous dalle",
            state: "default",
          },
          {
            id: "cp30",
            label:
              "Présence de la prise de terre (Câblette terre liée aux aciers fondations)",
            state: "default",
          },
          {
            id: "cp31",
            label: "Nombre des plots sous dalle par rapport à l'étude béton",
            state: "default",
            associated_email_template_id: "model1",
            email_sent: false,
          },
          {
            id: "cp32",
            label: "Ferraillage de la dalle avant coulage",
            state: "default",
          },
          {
            id: "cp33",
            label: "Réalisation du soubassement, équerrage",
            state: "default",
          },
          {
            id: "cp34",
            label: "Réalisation de l'enduit de soubassement",
            state: "default",
          },
          {
            id: "cp35",
            label: "Coulage de la dalle",
            state: "default",
          },
          {
            id: "cp36",
            label:
              "Planéité de la dalle coulée + repérage point haut plateforme",
            state: "default",
          },
          {
            id: "cp37",
            label:
              "Remblaiement de la périphérie de la dalle pour sécurité du chantier",
            state: "default",
          },
          {
            id: "cp38",
            label: "Réalisation du traitement anti-termites",
            state: "not_applicable",
            photos_id: ["photo1"],
          },
          {
            id: "cp39",
            label: "Mise en place de la bâche anti-radon",
            state: "not_applicable",
          },
          {
            id: "cp40",
            label:
              "Pose des fourreaux - PTT - EDF - AEP - Raccordements techniques",
            state: "default",
          },
          {
            id: "cp41",
            label: "Plan de la charpente réceptionné",
            state: "default",
          },
          {
            id: "cp42",
            label: "Livraison de la charpente",
            state: "default",
          },
          {
            id: "cp43",
            label: "Livraison des coffres",
            state: "default",
          },
        ],
      },
      {
        id: "step10",
        label: "Trait de niveau RDC",
        controlpoints: [
          {
            id: "cp44",
            label: "Présence et contrôle du trait de un mètre",
            state: "default",
          },
        ],
      },
      {
        id: "step11",
        label: "Trait de niveau Etage",
        controlpoints: [
          {
            id: "cp45",
            label: "Présence et contrôle du trait de un mètre",
            state: "default",
          },
        ],
      },
      {
        id: "step12",
        label: "Maçonnerie",
        controlpoints: [
          {
            id: "cp46",
            label: "Hauteur sous plancher",
            state: "default",
          },
          {
            id: "cp47",
            label: "Validation des poteaux béton armé",
            state: "default",
          },
          {
            id: "cp48",
            label: "Élévation des murs",
            state: "default",
          },
          {
            id: "cp49",
            label:
              "Positionnement des ouvertures et vérification des dimensions",
            state: "default",
          },
          {
            id: "cp50",
            label: "Trémie d'escalier dimensions",
            state: "default",
          },
          {
            id: "cp51",
            label: "Position volets roulants",
            state: "default",
          },
          {
            id: "cp52",
            label: "Vérification des entrées d'air sur coffre VR",
            state: "default",
          },
          {
            id: "cp53",
            label:
              "Présence des sommiers en béton pour recevoir les sabots de la charpente",
            state: "default",
          },
          {
            id: "cp54",
            label: "Hauteur sous les coffres de VR",
            state: "default",
          },
          {
            id: "cp55",
            label: "Hauteur arase",
            state: "default",
          },
          {
            id: "cp56",
            label: "Positionnement du trou d'homme",
            state: "default",
          },
          {
            id: "cp57",
            label: "Réalisation des seuils et appuis",
            state: "default",
          },
          {
            id: "cp58",
            label: "Réalisation de la dallette pour PAC",
            state: "default",
          },
        ],
      },
      {
        id: "step13",
        label: "Charpente",
        controlpoints: [
          {
            id: "cp59",
            label: "Position du CF",
            state: "default",
          },
          {
            id: "cp60",
            label: "Dimensions du chevêtre",
            state: "default",
          },
          {
            id: "cp61",
            label: "Validation de la date de la couverture",
            state: "default",
          },
          {
            id: "cp62",
            label: "Pose de la charpente",
            state: "default",
          },
          {
            id: "cp63",
            label: "Fixation à la maçonnerie",
            state: "default",
          },
          {
            id: "cp64",
            label: "Positionnement des réservations pour VELUX",
            state: "default",
          },
          {
            id: "cp65",
            label: "Pas de contreventement au passage de la trémie",
            state: "default",
          },
          {
            id: "cp66",
            label:
              "Contrôle des anti-flambements, contreventements, étrésillons",
            state: "default",
          },
          {
            id: "cp67",
            label:
              "Hauteur du dessous des entraits par rapport à la dalle brute",
            state: "default",
          },
        ],
      },
      {
        id: "step14",
        label: "Couverture",
        controlpoints: [
          {
            id: "cp68",
            label: "Pose de la couverture",
            state: "default",
          },
          {
            id: "cp69",
            label: "Date d'intervention pour les menuiseries extérieures",
            state: "default",
          },
          {
            id: "cp70",
            label: "Vérification du bon modèle des tuiles",
            state: "default",
          },
          {
            id: "cp71",
            label: "Pose des panneaux",
            state: "default",
            photos_id: ["photo2", "photo3"],
          },
          {
            id: "cp72",
            label: "Pose des abouts de faitage",
            state: "default",
          },
          {
            id: "cp73",
            label: "Mise en place d'un écran sous toiture (si prévu)",
            state: "default",
          },
          {
            id: "cp74",
            label: "Litonage et contre-litonage (si volige ou écran)",
            state: "default",
          },
          {
            id: "cp75",
            label: "Mise en place du faîtage (sens du faîtage)",
            state: "default",
          },
          {
            id: "cp76",
            label: "Scellement bas de pente",
            state: "default",
          },
          {
            id: "cp77",
            label: "Positionnement et nombre des tuiles à douilles",
            state: "default",
          },
          {
            id: "cp78",
            label: "Pose de la souche de cheminée",
            state: "not_applicable",
          },
          {
            id: "cp79",
            label: "Étanchéité de la casquette",
            state: "not_applicable",
          },
          {
            id: "cp80",
            label: "Bavette - solin - noue - zinc",
            state: "default",
          },
        ],
      },
      {
        id: "step15",
        label: "Toit terrasse - Toit plat",
        controlpoints: [
          {
            id: "cp81",
            label: "Plan de réservation des sorties de toiture",
            state: "not_applicable",
          },
          {
            id: "cp82",
            label: "Mise en place des bacs aciers ou de l'OSB",
            state: "not_applicable",
          },
          {
            id: "cp83",
            label: "Pente de 3% pour toit terrasse",
            state: "not_applicable",
          },
          {
            id: "cp84",
            label: "Mise en place de l'isolant de toit (selon étude thermique)",
            state: "not_applicable",
          },
          {
            id: "cp85",
            label: "Remontée d'étanchéité sur les murs (mini 15 cm)",
            state: "not_applicable",
          },
          {
            id: "cp86",
            label: "Mise en place de la membrane d'étanchéité",
            state: "not_applicable",
          },
          {
            id: "cp87",
            label: "Positionnement des évacuations de toit",
            state: "not_applicable",
          },
          {
            id: "cp88",
            label: "Pose du conduit feu",
            state: "not_applicable",
          },
          {
            id: "cp89",
            label: "Positionnement et nombre des trop-pleins",
            state: "not_applicable",
          },
          {
            id: "cp90",
            label:
              "Pose des couvertines sur acrotères + positionnement des sorties de toiture",
            state: "not_applicable",
          },
        ],
      },
      {
        id: "step16",
        label: "Menuiseries extérieures",
        controlpoints: [
          {
            id: "cp91",
            label: "Pose des menuiseries extérieures",
            state: "default",
          },
          {
            id: "cp92",
            label: "Date d'intervention enduiseur",
            state: "default",
          },
          {
            id: "cp93",
            label:
              "Prise de RDV avec le client sur chantier pour la validation de la pose des menuiseries + remise des clés",
            state: "default",
          },
          {
            id: "cp94",
            label: "Livraison des portes intérieures",
            state: "default",
          },
          {
            id: "cp95",
            label: "Aplomb",
            state: "default",
          },
          {
            id: "cp96",
            label: "Protection des menuiseries",
            state: "default",
          },
          {
            id: "cp97",
            label: "Vérifier la livraison des produits et état à la livraison",
            state: "default",
          },
          {
            id: "cp98",
            label: "Présence du compribande",
            state: "default",
          },
          {
            id: "cp99",
            label: "Présence du joint intérieur",
            state: "default",
          },
          {
            id: "cp100",
            label: "Présence du joint extérieur",
            state: "default",
          },
          {
            id: "cp101",
            label: "Jointage autour des appuis de fenêtre",
            state: "default",
          },
        ],
      },
      {
        id: "step17",
        label: "Ravalement",
        controlpoints: [
          {
            id: "cp102",
            label: "Vérification du ou des coloris d'enduit",
            state: "default",
          },
          {
            id: "cp103",
            label: "Protection des menuiseries",
            state: "default",
          },
          {
            id: "cp104",
            label:
              "Prise de photos des menuiseries extérieures avant ravalement",
            state: "default",
          },
          {
            id: "cp105",
            label: "Réalisation du dégrossi",
            state: "default",
          },
          {
            id: "cp106",
            label: "Réalisation de l'enduit",
            state: "default",
          },
          {
            id: "cp107",
            label: "État du chantier après intervention",
            state: "default",
          },
          {
            id: "cp108",
            label:
              "Prise de photos des menuiseries extérieures après ravalement",
            state: "default",
          },
        ],
      },
    ],
  },
] as ProjectTheme[];

// Virgin themes: same structure as themes but all controlpoints in "default" state, no photos
export const default_themes: ProjectTheme[] = themes.map((theme) => ({
  ...theme,
  steps: theme.steps.map((step) => ({
    ...step,
    controlpoints: step.controlpoints.map((cp) => ({
      ...cp,
      state: "default" as const,
      photos_id: undefined,
      email: undefined,
    })),
  })),
}));

// Default folders with subfolders, no documents
export const default_folders: ProjectFolder[] = [
  {
    id: "folder_admin",
    name: "Administratif",
    sub_folders: [
      { id: "sub_permis", name: "Permis de construire" },
      { id: "sub_assurance", name: "Assurance" },
      { id: "sub_contrats", name: "Contrats" },
    ],
  },
  {
    id: "folder_technique",
    name: "Technique",
    sub_folders: [
      { id: "sub_plans", name: "Plans d'exécution" },
      { id: "sub_etudes", name: "Études" },
      { id: "sub_be", name: "Bureau d'études" },
    ],
  },
  {
    id: "folder_financier",
    name: "Financier",
    sub_folders: [
      { id: "sub_devis", name: "Devis" },
      { id: "sub_factures", name: "Factures" },
      { id: "sub_avenants", name: "Avenants" },
    ],
  },
  {
    id: "folder_chantier",
    name: "Chantier",
    sub_folders: [
      { id: "sub_photos", name: "Photos de chantier" },
      { id: "sub_cr", name: "Comptes rendus de réunion" },
      { id: "sub_pv", name: "PV de réception" },
    ],
  },
  {
    id: "folder_client",
    name: "Client",
    sub_folders: [
      { id: "sub_correspondance", name: "Correspondance" },
      { id: "sub_notices", name: "Notices descriptives" },
    ],
  },
];

export const history_data: ProjectHistoryEvent[] = [
  {
    id: "1",
    action: "a créé le projet",
    user: {
      id: "user1",
      display_name: "Alice Dupont",
      photo_url: "https://blogs-cdn.imagine.art/3_D_1_7a47e0aa52.webp",
    },
    date: getFlutterFromDate(new Date("2023-01-15 10:30")),
  },
  {
    id: "2",
    action: "a ajouté 2 documents",
    user: {
      id: "user2",
      display_name: "Bob Martin",
      photo_url:
        "https://img.freepik.com/premium-photo/cartoon-character-girl-with-long-brown-hair_1267893-16105.jpg",
    },

    date: getFlutterFromDate(new Date("2023-01-20 14:45")),
    documents_id: ["doc1", "doc2"],
  },
  {
    id: "3",
    action: "a modifié les informations du projet",
    user: {
      id: "user3",
      display_name: "Claire Bernard",
      photo_url:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYU4g4GM3rNxTabtXMuU2o8W9xKG-8vW14ig&s",
    },

    date: getFlutterFromDate(new Date("2023-01-25 09:15")),
  },
  {
    id: "4",
    action: "a indiqué l'étape 'Terrassement' comme complétée",
    user: {
      id: "user1",
      display_name: "Alice Dupont",
      photo_url: "https://blogs-cdn.imagine.art/3_D_1_7a47e0aa52.webp",
    },

    date: getFlutterFromDate(new Date("2023-01-30 16:00")),
    control_point: {
      id: "task1",
      name: "Terrassement",
      new_status: "completed",
    },
  },
  {
    id: "5",
    action: "a ajouté 3 photos du chantier",
    user: {
      id: "user2",
      display_name: "Bob Martin",
      photo_url:
        "https://img.freepik.com/premium-photo/cartoon-character-girl-with-long-brown-hair_1267893-16105.jpg",
    },
    date: getFlutterFromDate(new Date("2023-02-02 11:20")),
    photos_id: ["photo1", "photo2", "photo3"],
  },
  {
    id: "6",
    action: "a envoyé un email au client",
    user: {
      id: "user1",
      display_name: "Alice Dupont",
      photo_url: "https://blogs-cdn.imagine.art/3_D_1_7a47e0aa52.webp",
    },
    date: getFlutterFromDate(new Date("2023-02-10 13:50")),
    email: {
      email_sent_id: "email1",
      template_id: "model1",
      sent: true,
      subject: "Mise à jour sur l'avancement de votre projet",
      body: "Bonjour Jean,\n\nJe vous écris pour vous informer de l'avancement de votre projet. Nous avons atteint une étape importante et nous sommes ravis de partager les progrès réalisés jusqu'à présent.\n\nCordialement,\nAlice",
    },
  },
];

export const sample_partners: PartnerInfos[] = [
  {
    id: "part1",
    role: "Architecte",
    display_name: "Sophie Martin",
    phone_number: "0987654321",
    email: "sophine@archi.com",
    company_name: "Sophie Martin Architecture",
    company_types: ["architecte"],
    company_email: "contact@archi.com",
  },
  {
    id: "part2",
    role: "Bureau d'études",
    display_name: "Marc Durand",
    phone_number: "0876543210",
    email: "xyz@etudes.com",
    company_name: "Bureau d'études XYZ",
    company_types: ["bureau_d_etudes"],
  },
  {
    id: "part3",
    role: "Entreprise de construction",
    display_name: "Julie Dupuis",
    phone_number: "0765432109",
    email: "abc@constru.com",
    company_name: "Construction ABC",
    company_types: ["menuiserie"],
  },
  {
    id: "part4",
    role: "Plombier",
    display_name: "Thomas Leroy",
    phone_number: "0654321098",
    email: "thomas@plomberie-leroy.fr",
    company_name: "Plomberie Leroy",
    company_types: ["plomberie"],
    company_email: "contact@plomberie-leroy.fr",
  },
  {
    id: "part5",
    role: "Électricien",
    display_name: "Camille Bernard",
    phone_number: "0543210987",
    email: "camille@elec-pro.fr",
    company_name: "Elec Pro Services",
    company_types: ["electricite"],
    company_email: "info@elec-pro.fr",
  },
  {
    id: "part6",
    role: "Peintre",
    display_name: "Antoine Moreau",
    phone_number: "0612345678",
    email: "antoine@moreau-peinture.fr",
    company_name: "Moreau Peinture",
    company_types: ["autre_btp"],
    company_email: "contact@moreau-peinture.fr",
  },
];

export const sample_sent_emails: EmailSent[] = [
  {
    id: "email1",
    subject: "Mise à jour sur l'avancement de votre projet",
    body: "Bonjour Jean,\n\nJe vous écris pour vous informer de l'avancement de votre projet. Nous avons atteint une étape importante et nous sommes ravis de partager les progrès réalisés jusqu'à présent.\n\nCordialement,\nAlice",
    created_at: getFlutterFromDate(new Date("2023-02-10 13:50")),
    emails_to: ["jean@dupont.fr"],
    emails_cc: [],
    files: [],
    email_template_id: "model1",
    sender_user_id: "user1",
    project_id: "folder1",
  },
];

export const sample_contacts: ContactInfos[] = [
  {
    first_name: "Jean",
    last_name: "Dupont",
    phone_number: "0123456789",
    email: "jean@dupont.fr",
    prefix: "M.",
  },
  {
    first_name: "Claire",
    last_name: "Dupont",
    phone_number: "0123456789",
    email: "claire@dupont.fr",
    prefix: "Mme",
  },
];

export const sampleProjects: Project[] = [
  {
    id: "folder1",
    infos: {
      general: {
        name: "Projet Alpha",
        num: "A001",
        city: "Paris",
        postal: "75002",
        address: "12 Rue de la Paix",
        photo_file: sample_photos[0].file,
        creation_date: getFlutterFromDate(new Date("2021-07-01")),
        last_updated: getFlutterFromDate(new Date("2021-07-15")),
        coordinates: {
          latitude: 48.867,
          longitude: 2.331,
        },
      },
      team: {
        commercial_id: "1",
        comptability_id: "3",
      },
      client: {
        contacts: sample_contacts,
      },
      partners: sample_partners.slice(0, 2),
    },
    status: "in_progress",
    org_id: "org1",
    author_id: "user1",
    history_events: history_data,
    themes: themes,
    photos: sample_photos,
    folders: sample_folders,
  },
  {
    id: "folder2",
    infos: {
      general: {
        name: "Projet Beta",
        num: "B002",
        city: "Lyon",
        postal: "69001",
        address: "45 Avenue des Champs",
        photo_file: sample_photos[1].file,
        creation_date: getFlutterFromDate(new Date("2021-08-01")),
        last_updated: getFlutterFromDate(new Date("2021-08-10")),
        coordinates: {
          latitude: 45.758,
          longitude: 4.841,
        },
      },
      team: {
        commercial_id: "2",
        comptability_id: "5",
      },
      client: {
        contacts: sample_contacts,
      },
      partners: sample_partners.slice(0, 2),
    },
    status: "completed",
    org_id: "org1",
    author_id: "user2",
    history_events: history_data,
    themes: themes,
    photos: sample_photos,
    folders: sample_folders,
  },
  {
    id: "folder3",
    infos: {
      general: {
        name: "Projet Gamma",
        num: "C003",
        city: "Marseille",
        postal: "13001",
        address: "78 Boulevard du Port",
        photo_file: sample_photos[2].file,
        creation_date: getFlutterFromDate(new Date("2021-09-01")),
        last_updated: getFlutterFromDate(new Date("2021-09-20")),
        coordinates: {
          latitude: 43.296,
          longitude: 5.369,
        },
      },
      team: {
        commercial_id: "1",
        comptability_id: "4",
      },
      client: {
        contacts: sample_contacts,
      },
      partners: sample_partners.slice(0, 2),
    },
    status: "not_started",
    org_id: "org1",
    author_id: "user3",
    history_events: history_data,
    themes: themes,
    photos: sample_photos,
    folders: sample_folders,
  },
  {
    id: "folder4",
    infos: {
      general: {
        name: "Projet Delta",
        num: "D004",
        city: "Toulouse",
        postal: "31000",
        address: "23 Place du Capitole",
        photo_file: sample_photos[0].file,
        creation_date: getFlutterFromDate(new Date("2021-10-01")),
        last_updated: getFlutterFromDate(new Date("2021-10-15")),
        coordinates: {
          latitude: 43.604,
          longitude: 1.444,
        },
      },
      team: {
        commercial_id: "3",
        comptability_id: "6",
      },
      client: {
        contacts: sample_contacts,
      },
      partners: sample_partners.slice(0, 2),
    },
    status: "in_progress",
    org_id: "org1",
    author_id: "user1",
    history_events: history_data,
    themes: themes,
    photos: sample_photos,
    folders: sample_folders,
  },
];

export const sample_email_models: EmailTemplate[] = [
  {
    id: "model1",
    name: "Confirmation de rendez-vous",
    subject: "Confirmation de rendez-vous",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "client",
    body: `Bonjour Madame [ automatique ], Monsieur [ automatique ],

je vous confirme notre rendez-vous du [ compléter la date ] à [ compléter l'heure ] qui aura lieu [ compléter le lieu ].

Je reste bien entendu à votre disposition en cas d’empêchement ou de modification.

Bonne journée.

[Signature automatique ]
    `,
  },
  {
    id: "model2",
    name: "Validation des plans d'exécution",
    subject: "Validation des plans d'exécution",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "client",
    body: `Bonjour  Madame [ automatique ], Monsieur [ automatique ],
vous trouverez ci-joints vos plans d’exécution pour validation.
 
Nous vous remercions de bien vouloir les examiner et nous retourner les plans signés si ceux là vous conviennent.

Je reste bien entendu à votre disposition pour toute question ou demande de précision.
 
[ Signature automatique]
 `,
  },
  {
    id: "model3",
    name: "Confirmation chantier prêt",
    subject: "Confirmation chantier prêt",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "partner",
    body: `Bonjour,
le chantier de Madame [ automatique ]et Monsieur [ automatique ],

situé [ automatique ] est prêt pour votre intervention [ compléter le nom de l'intervention ].

Vous pouvez intervenir à partir du [ date ].

Merci de me confirmer votre date d'intervention.

Je reste disponible si besoin.

Bonne journée.

[ Signature automatique ]
 `,
  },

  {
    id: "model4",
    name: "Information retard chantier",
    subject: "Information retard chantier",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "partner",
    body: `Bonjour, pour information,

Le chantier de @contact_1 et @contact_2, situé @adresse_projet a pris du retard.

Merci de bien vouloir décaler votre intervention à partir du @date.

Je vous remercie de me confirmer votre nouvelle date de passage.

Bonne journée.

@signature
    `,
  },
  {
    id: "model5",
    name: "Ouverture compteur d'eau",
    subject: "Ouverture compteur d'eau",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "client",
    body: `Bonjour Madame [ automatique ], Monsieur [ automatique ],

Nous vous invitons à procéder à l’ouverture de votre compteur d’eau si cela n’est pas déjà fait.

Il vous suffit de contacter le fournisseur d’eau de votre commune.

Vous trouverez le PDF ci-dessous.

Bonne journée.

[Signature automatique ]
    `,
    library_documents_id: ["libdoc1"],
  },
  {
    id: "model6",
    name: "Pose du compteur provisoire",
    subject: "Pose du compteur provisoire",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "client",
    body: `Bonjour @contact_1, @contact_2,
    
Nous vous invitons à procéder à l’installation de votre compteur de chantier si cela n’est pas déjà fait.
  
Les artisans auront besoin de l'électricité pour pouvoir réaliser les travaux.

Vous pouvez consulter ci-dessous, les instructions pour obtenir l'alimentation électrique de votre compteur de chantier.

Bonne journée.

@signature
    `,
    library_documents_id: ["libdoc2"],
  },
  {
    id: "model7",
    name: "Rappel dépôt de la DROC",
    subject: "Rappel dépôt de la DROC",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "client",
    body: `Bonjour @contact_1, @contact_2,

Votre chantier vient de débuter,

Vous devez donc procéder à votre déclaration d'ouverture de chantier.

Bonne journée.

@signature
    `,
  },
  {
    id: "model8",
    name: "Livraison de la charpente",
    subject: "Livraison de la charpente",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "partner",
    body: `Bonjour [ entreprise charpente ],

Merci de procéder à la livraison de la charpente pour le chantier [ automatique ] situé [automatique].

Merci d'avance.

Bonne journée

[signature ].
  
    `,
  },
  {
    id: "model9",
    name: "Livraison des coffres de VR",
    subject: "Livraison des coffres de VR",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "partner",
    body: `Bonjour [ entreprise de menuiserie ],

Merci de procéder à la livraison des coffres de VR pour le chantier [ automatique ] situé [automatique].

Merci d'avance.

Bonne journée

[signature ]
    `,
  },
  {
    id: "model10",
    name: "Prévoir l'intervention des réseaux sous dalle",
    subject: "Prévoir l'intervention des réseaux sous dalle",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "partner",
    body: `Bonjour,

Merci de prévoir l'intervention des réseaux sous dalle pour le chantier [ automatique ] situé [automatique]  pour le : date,

Merci de me confirmer votre date d'intervention.

Je reste disponible si besoin.

Bonne journée.

[ Signature automatique ].
    `,
    mandatory_photo: true,
  },
  {
    id: "model11",
    name: "Livraison des coffres pour le chantier",
    subject: "Livraison des coffres pour le chantier",
    created_at: getFlutterFromDate(new Date("2024-06-01 10:00")),
    destination_type: "partner",
    body: `Bonjour,

Merci de procéder à la livraison des coffres pour le chantier [ automatique ] situé [automatique]  pour le : date,

Merci de me confirmer votre date d'intervention.

Je reste disponible si besoin.

Bonne journée.

[ Signature automatique ]
    `,
    mandatory_photo: true,
  },
];
interface User {
  id: string;
  email: string;
  photo_url: string;
  created_time: Timestamp;
  phone_number: string;
  display_name: string;
  full_name: string;
  admin?: boolean;
  org_id: string;
  maintenance_proof?: boolean;
  org_admin?: boolean;
  signature_id?: string;
  color_tag: string;
  role: string;
  last_active: Timestamp;
  connected: boolean;
}

export const sample_users: User[] = [
  {
    id: "user1",
    display_name: "Alice D",
    email: "alice@life.com",
    photo_url: "",
    role: "conductor",
    last_active: getFlutterFromDate(new Date("2024-06-10 09:30")),
    color_tag: colors.blue_800,
    connected: true,
    created_time: getFlutterFromDate(new Date()),
    full_name: "Alice Dupont",
    phone_number: "0123456789",
    org_id: "org1",
  },
  {
    id: "user2",
    display_name: "Bob M",
    email: "bob@life.com",
    photo_url: "",
    role: "admin",
    last_active: getFlutterFromDate(new Date("2024-06-09 14:15")),
    color_tag: colors.purple_500,
    connected: false,
    created_time: getFlutterFromDate(new Date()),
    full_name: "Bob Martin",
    phone_number: "0987654321",
    org_id: "org1",
  },
  {
    id: "user3",
    display_name: "Claire B",
    email: "claire@life.com",
    photo_url: "",
    role: "viewer",
    last_active: getFlutterFromDate(new Date("2024-06-08 11:45")),
    color_tag: colors.blue_400,
    connected: true,
    created_time: getFlutterFromDate(new Date()),
    full_name: "Claire Bernard",
    phone_number: "0612345678",
    org_id: "org1",
  },
];

export const role_dict = {
  admin: "Administrateur",
  conductor: "Conducteur de travaux",
  commercial: "Commercial",
  sav: "SAV",
  comptability: "Comptabilité",
  communication: "Communication",
  viewer: "Dessinateur",
};

export const sampleBroadcasts: Broadcast[] = [
  {
    id: "broadcast1",
    title: "Vacances de Noël",
    content:
      "Bonjour,\n\nJe serai en congés à partir du lundi 23 décembre et serai de retour le lundi 06 janvier 2026.\n\nEn cas de besoin, vous pouvez m'envoyer un mail, je reviendrai vers vous dès mon retour.\n\nBelle journée,\nCordialement,\nPhilippine",
    author: {
      id: "user1",
      display_name: "Philippine",
      color_tag: "#EC4899",
    },
    org_id: "org1",
    start_date: getFlutterFromDate(new Date("2025-12-23")),
    end_date: getFlutterFromDate(new Date("2026-01-06")),
    status: "active",
    created_at: getFlutterFromDate(new Date("2025-12-20 09:00")),
    updated_at: getFlutterFromDate(new Date("2025-12-20 09:00")),
  },
  {
    id: "broadcast2",
    title: "Pont d'octobre 26-29",
    content:
      "Bonjour,\n\nJe serai en congés du vendredi 26 au mardi 29 octobre inclus.\n\nPour toute urgence, merci de contacter l'accueil.\n\nCordialement,\nVincent",
    author: {
      id: "user2",
      display_name: "Vincent",
      color_tag: "#F97316",
    },
    org_id: "org1",
    start_date: getFlutterFromDate(new Date("2025-10-26")),
    end_date: getFlutterFromDate(new Date("2025-10-29")),
    status: "active",
    created_at: getFlutterFromDate(new Date("2025-10-20 14:30")),
    updated_at: getFlutterFromDate(new Date("2025-10-20 14:30")),
  },
  {
    id: "broadcast3",
    title: "Pont de septembre 14",
    content:
      "Bonjour,\n\nLe bureau sera fermé le lundi 14 septembre.\n\nNous serons de retour le mardi 15 septembre.\n\nBonne fin de semaine,\nVincent",
    author: {
      id: "user2",
      display_name: "Vincent",
      color_tag: "#F97316",
    },
    org_id: "org1",
    start_date: getFlutterFromDate(new Date("2025-09-14")),
    end_date: getFlutterFromDate(new Date("2025-09-14")),
    status: "inactive",
    created_at: getFlutterFromDate(new Date("2025-09-10 10:00")),
    updated_at: getFlutterFromDate(new Date("2025-09-10 10:00")),
  },
  {
    id: "broadcast4",
    title: "Réunion d'équipe mensuelle",
    content:
      "Bonjour à tous,\n\nRappel : la réunion d'équipe mensuelle aura lieu le premier lundi de chaque mois à 9h30 en salle de conférence.\n\nOrdre du jour :\n- Point sur les projets en cours\n- Retours clients\n- Planning du mois\n\nMerci de confirmer votre présence.\n\nCordialement,\nEmelyne",
    author: {
      id: "user3",
      display_name: "Emelyne",
      color_tag: "#8B5CF6",
    },
    org_id: "org1",
    start_date: getFlutterFromDate(new Date("2025-11-03")),
    end_date: getFlutterFromDate(new Date("2026-12-31")),
    status: "active",
    created_at: getFlutterFromDate(new Date("2025-11-01 08:00")),
    updated_at: getFlutterFromDate(new Date("2025-11-01 08:00")),
  },
  {
    id: "broadcast5",
    title: "Maintenance informatique",
    content:
      "Bonjour,\n\nUne maintenance informatique est prévue le samedi 15 février 2026 de 8h à 12h.\n\nLes services en ligne seront temporairement indisponibles.\n\nMerci de votre compréhension.\n\nLe service informatique",
    author: {
      id: "user1",
      display_name: "Philippine",
      color_tag: "#EC4899",
    },
    org_id: "org1",
    start_date: getFlutterFromDate(new Date("2026-02-15")),
    end_date: getFlutterFromDate(new Date("2026-02-15")),
    status: "active",
    created_at: getFlutterFromDate(new Date("2026-02-10 11:00")),
    updated_at: getFlutterFromDate(new Date("2026-02-10 11:00")),
  },
  {
    id: "broadcast6",
    title: "Fermeture estivale",
    content:
      "Bonjour,\n\nLe bureau sera fermé du 1er au 15 août 2025.\n\nNous vous souhaitons un bel été !\n\nCordialement,\nL'équipe",
    author: {
      id: "user3",
      display_name: "Emelyne",
      color_tag: "#8B5CF6",
    },
    org_id: "org1",
    start_date: getFlutterFromDate(new Date("2025-08-01")),
    end_date: getFlutterFromDate(new Date("2025-08-15")),
    status: "inactive",
    created_at: getFlutterFromDate(new Date("2025-07-20 16:00")),
    updated_at: getFlutterFromDate(new Date("2025-07-20 16:00")),
  },
];
